module.exports = __webpack_public_path__ + "static/img/20.ce0300a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/20.png
// module id = 0grP
// module chunks = 0